import { createContext, useContext } from "react";

const WidgetConfigContext = createContext<{
  studioId: string;
} | null>(null);

export function WidgetConfigProvider({
  studioId,
  children,
}: {
  studioId: string;
  children: React.ReactNode;
}) {
  return (
    <WidgetConfigContext.Provider value={{ studioId }}>
      {children}
    </WidgetConfigContext.Provider>
  );
}

export function useWidgetConfig() {
  const ctx = useContext(WidgetConfigContext);
  if (!ctx) {
    throw new Error("WidgetConfigProvider missing");
  }
  return ctx;
}
